export default {
  data () {
    return {
      elSize: {
        width: 0,
        height: 0,
      },
      elSizeResizeObserver: null,
    };
  },
  methods: {
    updateTrackedWidgetSize (arg) {
      if (process.env.NODE_ENV === 'development') {
          console.warn('[DEV] elSize.js: resizeObserver triggered');
      }
      if (arg && arg.contentRect) {
        this.setSize(arg.contentRect);
      } else {
        const rect = this.$el.getBoundingClientRect();
        this.setSize(rect);
      }
    },
    setSize ({ width, height }) {
      if (width !== this.elSize.width || height !== this.elSize.height) {
        this.elSize = {
          width,
          height,
        };
      }
    }
  },
  beforeUnmount () {
    if (this.elSizeResizeObserver) {
      this.elSizeResizeObserver.disconnect();
      this.elSizeResizeObserver = null;
    }
  },
  mounted () {
    if (! this.$el) {
      console.error('Could not find element to track size', this);
      return;
    }

    this.updateTrackedWidgetSize();

    if (ResizeObserver) {
      this.elSizeResizeObserver = new ResizeObserver(this.updateTrackedWidgetSize).observe(this.$el);
    } else {
      // Lazy fallback for browsers without ResizeObserver
      setTimeout(() => {
        this.updateTrackedWidgetSize();
      }, 300);
      setTimeout(() => {
        this.updateTrackedWidgetSize();
      }, 1000);
    }
  },
};
